import Navbar from "../../components/Layout/Navbar";
import Footer from "../../components/Layout/Footer";
import AB from "./image/about.jpeg"
import AB2 from "./image/about2.jpeg"
import PageMeta from "../../components/pagesHelmet/PageMeta";

const BRAND = {
  primary: "#3B82F6",
  primaryDark: "#2563EB",
  primarySoft: "rgba(59, 130, 246, 0.1)",
  success: "#22C55E",
  warning: "#F59E0B",
  muted: "#6B7280",
  text: "#1F2937",
};

export default function AboutPage() {
  return (
    <>
    <PageMeta
      title="About Us | U2LR URL Shortener"
      description="Learn more about U2LR, the all-in-one link management platform offering branded URL shorteners, dynamic QR codes, and real-time analytics to help you grow your business."
    />
      <Navbar />

      <div style={{ color: BRAND.text }}>

        {/* ================= HERO ================= */}
        <section
          style={{
            background: `linear-gradient(135deg, #000, #4b76d1)`,
            color: "#fff",
          }}
        >
          <div className="container py-5">
            <div className="row py-5 align-items-center">
              <div className="col-lg-6">
                <h1 className="display-5 fw-bold mb-4">About u2lr</h1>
                <p className="lead" style={{ color: "rgba(255,255,255,0.85)" }}>
                  u2lr exists to make links simpler, clearer, and more trustworthy.
                </p>
              </div>

              <div className="col-lg-6 text-center">
                <img
                  src={AB2}
                  alt="u2lr dashboard"
                  className="img-fluid rounded-4 shadow-lg"
                />
              </div>
            </div>
          </div>
        </section>

        {/* ================= INTRO ================= */}
        <section className="py-5">
          <div className="container py-4">
            <div className="row justify-content-center">
              <div className="col-lg-9 text-center">
                <p className="fs-5" style={{ color: BRAND.muted }}>
                  The internet runs on links, but long, messy URLs make sharing harder and
                  tracking performance confusing. We built u2lr to solve that problem in a
                  straightforward way: shorten links, understand how they perform, and
                  manage them responsibly, all in one place.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ================= WHAT WE DO ================= */}
        <section className="py-5" style={{ background: BRAND.primarySoft }}>
          <div className="container py-4">
            <div className="text-center mb-5">
              <h2 className="fw-bold">What We Do</h2>
              <p style={{ color: BRAND.muted }}>
                u2lr is a link-shortening and link-management platform.
              </p>
            </div>

            <div className="row g-4">
              {[
                "Turn long URLs into clean, shareable links",
                "Track clicks and basic engagement with clear analytics",
                "Organize, manage, and update links from one dashboard",
              ].map((text, i) => (
                <div key={i} className="col-md-4">
                  <div className="card h-100 border-0 shadow-sm rounded-4">
                    <div className="card-body p-4">
                      <div
                        className="fw-bold mb-3"
                        style={{ color: BRAND.primary, fontSize: "1.75rem" }}
                      >
                        ✓
                      </div>
                      <p className="fs-5 mb-0">{text}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <p className="text-center mt-4" style={{ color: BRAND.muted }}>
              No unnecessary complexity. Just tools that do what they’re supposed to do.
            </p>
          </div>
        </section>

        {/* ================= WHO IT'S FOR ================= */}
        <section className="py-5">
          <div className="container py-4">
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <img
                  src={AB}
                  alt="Who u2lr is built for"
                  className="img-fluid rounded-4 shadow"
                />
              </div>

              <div className="col-lg-6">
                <h2 className="fw-bold mb-4">Who u2lr Is Built For</h2>
                <ul className="list-unstyled fs-5" style={{ color: BRAND.muted }}>
                  <li className="mb-2">✓ Content creators and influencers</li>
                  <li className="mb-2">✓ Startups and growing teams</li>
                  <li className="mb-2">✓ Businesses sharing campaigns and resources</li>
                  <li className="mb-2">✓ Marketers who need clarity on link performance</li>
                </ul>
                <p style={{ color: BRAND.muted }}>
                  Whether you’re sharing one link or managing many, u2lr fits naturally
                  into your workflow.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* ================= BACKGROUND ================= */}
        <section className="py-5 bg-light">
          <div className="container py-4 text-center">
            <h2 className="fw-bold mb-3">Our Background</h2>
            <p className="fs-5 mx-auto" style={{ maxWidth: 820, color: BRAND.muted }}>
              u2lr was developed by <strong>TegaFate HuB</strong>, a product-focused
              development hub dedicated to building practical digital tools.
              <br /><br />
              The platform was founded between 2020 and 2026, shaped by real-world use
              cases and feedback from people who needed a reliable way to manage links
              without unnecessary friction.
            </p>
          </div>
        </section>

        {/* ================= SECURITY ================= */}
        <section className="py-5">
          <div className="container py-4">
            <div className="row align-items-center g-5">
              <div className="col-lg-6">
                <h2 className="fw-bold mb-4">
                  Security, Transparency & Responsible Use
                </h2>
                <p style={{ color: BRAND.muted }}>
                  Trust matters when links are involved. We take a responsible approach
                  to how u2lr is built and operated.
                </p>
                <ul className="list-unstyled" style={{ color: BRAND.muted }}>
                  <li>✓ Secure infrastructure and safe link handling</li>
                  <li>✓ Transparent platform behavior</li>
                  <li>✓ Active discouragement of misuse and spam</li>
                </ul>
              </div>

              <div className="col-lg-6">
                <img
                  src={AB}
                  alt="Security"
                  className="img-fluid rounded-4"
                />
              </div>
            </div>
          </div>
        </section>

        {/* ================= TEAM ================= */}
        <section className="py-5 bg-light">
          <div className="container py-4 text-center">
            <h2 className="fw-bold mb-3">The Team Behind u2lr</h2>
            <p className="mx-auto mb-4" style={{ maxWidth: 820, color: BRAND.muted }}>
              u2lr is built and maintained by a small, dedicated team of engineers,
              designers, and product builders who believe software should be simple,
              reliable, and respectful of its users.
            </p>

            <img
              src={AB2}
              alt="u2lr team"
              className="img-fluid rounded-4 shadow-lg"
            />
          </div>
        </section>

        {/* ================= FUTURE ================= */}
        <section className="py-5">
          <div className="container py-4 text-center">
            <h2 className="fw-bold mb-3">Looking Ahead</h2>
            <p className="fs-5 mx-auto" style={{ maxWidth: 820, color: BRAND.muted }}>
              u2lr is a long-term project. We’re committed to steady improvements,
              listening to our users, and building tools that remain useful as the web
              evolves.
              <br /><br />
              No shortcuts. No hype. Just consistent work toward a product people can
              trust over time.
            </p>
          </div>
        </section>

        {/* ================= CTA ================= */}
        <section
          className="text-white text-center py-5"
          style={{ backgroundColor: "#ffff" }}
        >
          <div className="container py-4">
            <h2 className="fw-bold mb-3" style={{ color: "rgba(28, 5, 5, 0.85)" }}>Thank you for choosing u2lr</h2>
            <p className="mb-4" style={{ color: "rgba(28, 5, 5, 0.85)" }}>
              Start managing your links with clarity and confidence.
            </p>
            <a
              href="/register"
              className="btn btn-light btn-lg fw-semibold rounded-pill px-5"
              style={{ color: BRAND.primary }}
            >
              Get started
            </a>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
}
